export const DEFAULT_OUTCOME_DEFINITION = {
  inputSchema: {
    type: "object",
    properties: {
      distribution_strategy: {
        type: "string",
        title: "Distribution Strategy",
        enum: ["ORDER_BASED", "PROBABILITY_BASED"],
        enumLabels: {
          ORDER_BASED: "Order Based",
          PROBABILITY_BASED: "Probability Based",
        },
      },
      rollover_enabled: {
        type: "boolean",
        title: "Fallback Logic",
        description:
          "Assign the next eligible reward when the current reward is exhausted.",
      },
      pool_user_win_limits: {
        type: "object",
        properties: {
          wins_overall: { type: "integer", title: "Wins Overall" },
          wins_hourly: { type: "integer", title: "Max per hour" },
          wins_daily: { type: "integer", title: "Max per day" },
          wins_weekly: { type: "integer", title: "Max per week" },
          wins_monthly: { type: "integer", title: "Max per month" },
          wins_yearly: { type: "integer", title: "Max per year" },
        },
      },
      rewards: {
        type: "array",
        items: {
          type: "object",
          properties: {
            reward_id: {
              type: "string",
              title: "Reward ID",
              required: true,
              readonly: true,
            },
            reward_name: {
              type: "string",
              title: "Reward Name",
              required: true,
              readonly: true,
            },
            priority_order: { type: "integer", title: "Priority Order" },
            distribution_weight: {
              type: "number",
              title: "Distribution Weight",
              hidden: true,
            },
            status: { type: "string", title: "Status" },
          },
        },
      },
    },
  },
};

export const DEFAULT_WIN_LIMIT_FIELDS = [
  {
    key: "wins_overall",
    label: "Max per campaign",
    description:
      "Maximum number of times a user can win for the entire campaign duration",
  },
  {
    key: "wins_hourly",
    label: "Max per hour",
    description:
      "Maximum number of times a user can win through the activity in an hour",
  },
  {
    key: "wins_daily",
    label: "Max per day",
    description:
      "Maximum number of times a user can win through the activity in a day",
  },
  {
    key: "wins_weekly",
    label: "Max per week",
    description:
      "Maximum number of times a user can win through the activity in a week",
  },
  {
    key: "wins_monthly",
    label: "Max per month",
    description:
      "Maximum number of times a user can win through the activity in a month",
  },
  {
    key: "wins_yearly",
    label: "Max per year",
    description:
      "Maximum number of times a user can win through the activity in a year",
  },
];

export const DEFAULT_INVENTORY_LIMIT_TYPES = [
  {
    key: "total_quantity",
    label: "Total Quantity",
    description: "Total number of rewards available for all users",
  },
  {
    key: "hourly_limit",
    label: "Max per hour",
    description: "Maximum rewards per hour for all users",
  },
  {
    key: "daily_limit",
    label: "Max per day",
    description: "Maximum rewards per day for all users",
  },
  {
    key: "weekly_limit",
    label: "Max per week",
    description: "Maximum rewards per week for all users",
  },
  {
    key: "monthly_limit",
    label: "Max per month",
    description: "Maximum rewards per month for all users",
  },
  {
    key: "yearly_limit",
    label: "Max per year",
    description: "Maximum rewards per year for all users",
  },
];

export const DEFAULT_REWARD_FIELDS = [
  {
    key: "reward_id",
    label: "Reward ID",
    type: "string",
    required: true,
    readonly: true,
    field_type: "text",
  },
  {
    key: "reward_name",
    label: "Reward Name",
    type: "string",
    required: true,
    readonly: true,
    field_type: "text",
  },
  {
    key: "priority_order",
    label: "Priority Order",
    type: "integer",
    field_type: "number",
    required_when: { field: "distribution_strategy", value: "ORDER_BASED" },
  },
  {
    key: "distribution_weight",
    label: "Distribution Weight",
    type: "number",
    field_type: "number",
    required_when: { field: "distribution_strategy", value: "PROBABILITY_BASED" },
  },
];

export const DEFAULT_DISTRIBUTION_STRATEGIES = [
  { key: "ORDER_BASED", label: "Order Based" },
  { key: "PROBABILITY_BASED", label: "Probability Based" },
];

export const DEFAULT_REWARD_STATUSES = [
  { key: "ACTIVE", label: "Active" },
  { key: "INACTIVE", label: "Inactive" },
];

export const DEFAULT_WIN_LIMIT_TYPES = [
  {
    key: "wins_overall",
    label: "Max per campaign",
    description:
      "Maximum number of times a user can win for the entire campaign duration",
  },
  {
    key: "wins_hourly",
    label: "Max per hour",
    description:
      "Maximum number of times a user can win through the activity in an hour",
  },
  {
    key: "wins_daily",
    label: "Max per day",
    description:
      "Maximum number of times a user can win through the activity in a day",
  },
  {
    key: "wins_weekly",
    label: "Max per week",
    description:
      "Maximum number of times a user can win through the activity in a week",
  },
  {
    key: "wins_monthly",
    label: "Max per month",
    description:
      "Maximum number of times a user can win through the activity in a month",
  },
  {
    key: "wins_yearly",
    label: "Max per year",
    description:
      "Maximum number of times a user can win through the activity in a year",
  },
];
